import { useContext } from "react";
import LanguageContext from "../context/language";
import Icon from "./icon";
import useShareWidget from "../hooks/queries/useShareWidget";

const ShareWidget = ({ className }) => {
  const { labels } = useContext(LanguageContext);
  const { data: share, isError } = useShareWidget();

  return (
    !isError &&
    share && (
      <div {...(className ? { className } : {})}>
        <div className="share-widget">
          <Icon name="share-icon" />
          <span>
            {labels?.SHARE_PRICE}:{" "}
            <strong>
              {share.Valeur} {share.Unite}{" "}
            </strong>
            ({share.Variation})
          </span>
        </div>
      </div>
    )
  );
};

export default ShareWidget;
